import { Role as APIRole } from '@centecomm/portal-service';
import { Role } from '../Types/Role';

// eslint-disable-next-line import/prefer-default-export
export const mapBusinessInformationRolesAPIToBusinessRole = (apiRole: APIRole): Role => {
    const businessRole: Role = {
        id: apiRole.roleId,
        name: apiRole.name,
        description: apiRole.description,
    };

    // Default is a reserved keyword in JS - This should prevent runtime errors
    // eslint-disable-next-line dot-notation
    businessRole['default'] = apiRole['default'];

    return businessRole;
};
